module.exports = __webpack_public_path__ + "static/media/bg1.cc63d7fd.webp";